import { fetchMember } from '@general/api/memberAPI';
import reactQueryClient from '@general/reactQueryClient';

export const getMemberFromCache = async memberId => {
    const cachedMember = reactQueryClient.getQueryData(`member-${memberId}`);
    if (cachedMember) {
        return cachedMember;
    }

    const memberData = await fetchMember(memberId);
    reactQueryClient.setQueryData(`member-${memberId}`, memberData);
    return memberData;
};
